import React from 'react'
import classNames from 'classnames'

import DescendingIcon from 'images/common/sort-desc'
import AscendingIcon from 'images/common/sort-asc'
import './GridListTh.scss'

const GridListTh = ({ def, sortedBy, sortedAsc, setSortedBy, setSortedAsc, onSort, enableSort, changePage, transparentHead, isCompact, isNarrow, isBordered }) => {
  const { label, column } = def

  const isSortedBy = sortedBy === column
  const getSordOrder = sortedAsc ? 'asc' : 'desc'

  const onSortChange = () => {
    if (enableSort) {
      const updateOrder = isSortedBy ? !sortedAsc : true
      setSortedBy && setSortedBy(column)
      setSortedAsc && setSortedAsc(updateOrder)
      onSort && onSort(column, updateOrder)
      changePage && changePage(1)
    }
  }

  return (
    <th
      className={
        classNames(
          'viso-grid-list-th',
          isSortedBy && 'viso-grid-list-th--sortedBy',
          isCompact && 'viso-grid-list-th--compact',
          isNarrow && 'viso-grid-list-th--narrow',
          transparentHead && 'viso-grid-list-th--transparent',
          isBordered && 'viso-grid-list-th--bordered'
        )
      }
      onClick={onSortChange}
    >
      <div
        className={
          classNames(
            'viso-grid-list-th__label',
            enableSort && 'viso-grid-list-th__label--sortable',
            isSortedBy && 'viso-grid-list-th__label--sortedBy',
          )
        }
      >
        {label}
        {isSortedBy &&
          <div className='viso-grid-list-th__sort'>
            {getSordOrder === 'desc' ? <DescendingIcon iconClass='label' /> : <AscendingIcon iconClass='label' />}
          </div>
        }
      </div>
    </th>
  )
}

export default GridListTh